
import { Actions } from "@/store/enums/StoreEnums";
import { ref } from "vue";
import { useStore } from "vuex";
import Loading from "@/components/Loading.vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
export default {
    name: "NewLicitacion",
    emits: ["cancelar", "guardar"],
    components: {
        Loading,
        Field,
        Form,
        ErrorMessage,
    },
    data() {
        return {
            nombreLicitacion: "",
            fechaPublicacion: "",
            fechaTermino: "",
            ubicacion: "",
        };
    },
    setup(props, { emit }) {
        const store = useStore();
        const proveedores = ref([]);
        var loading = ref(false);
        const mensajeInputFechaPublicacion = ref(false);
        const mensajeInputFechaTermino = ref(false);
        const mensajeInputUbicacion = ref(false);
        const mensajeInputnombreLicitacion = ref(false);
        const submitButton = ref<HTMLButtonElement | null>(null);

        const licitacion = Yup.object().shape({
            nombreLicitacion: Yup.string()
                .min(5, "Debe tener un mínimo de 5 caracteres")
                .max(50, "Debe tener un máximo de 100")
                .required("Campo Requerido")
                .label("nombreLicitacion"),
            fechaPublicacion: Yup.string()
                .required("Campo Requerido")
                .label("fechaPublicacion"),
            fechaTermino: Yup.string()
                .required("Campo Requerido")
                .label("fechaTermino"),
            ubicacion: Yup.string()
                .min(5, "Debe tener un mínimo de 5 caracteres")
                .max(100, "Debe tener un máximo de 100")
                .required("Campo Requerido")
                .label("ubicacion"),
        });

        const cancelarCreacion = () => {
            emit("cancelar", null);
        };

        const onSubmit = async (values) => {
            loading.value = true;

            // eslint-disable-next-line
            submitButton.value!.disabled = true;

            submitButton.value?.setAttribute("data-kt-indicator", "on");
            var formData = new FormData();

            formData.append("nombreLicitacion", values.nombreLicitacion);
            formData.append("fechaPublicacion", values.fechaPublicacion);
            formData.append("fechaTermino", values.fechaTermino);
            formData.append("ubicacion", values.ubicacion);

            const data = await store.dispatch(
                Actions.CREATE_LICITACION,
                formData
            );
            emit("guardar", { data });
            loading.value = false;
        };

        const crearLicitacion = async (
            nombreLicitacion,
            fechaPublicacion,
            fechaTermino,
            ubicacion
        ) => {
            try {
                var error = false;
                mensajeInputFechaPublicacion.value = false;
                mensajeInputFechaTermino.value = false;
                mensajeInputUbicacion.value = false;
                mensajeInputnombreLicitacion.value = false;

                if (nombreLicitacion == "") {
                    mensajeInputnombreLicitacion.value = true;
                    error = true;
                }
                if (fechaPublicacion == "") {
                    mensajeInputFechaPublicacion.value = true;
                    error = true;
                }
                if (fechaTermino == "") {
                    mensajeInputFechaTermino.value = true;
                    error = true;
                }
                if (ubicacion == "") {
                    mensajeInputUbicacion.value = true;
                    error = true;
                }

                if (!error) {
                    loading.value = true;
                    var formData = new FormData();

                    formData.append("nombreLicitacion", nombreLicitacion);
                    formData.append("fechaPublicacion", fechaPublicacion);
                    formData.append("fechaTermino", fechaTermino);
                    formData.append("ubicacion", ubicacion);

                    const data = await store.dispatch(
                        Actions.CREATE_LICITACION,
                        formData
                    );
                    emit("guardar", { data });
                    loading.value = false;
                }
            } catch (error) {
                console.log(error);
                loading.value = false;
                emit("guardar", null);
            }
        };

        return {
            proveedores,
            cancelarCreacion,
            crearLicitacion,
            loading,
            mensajeInputFechaPublicacion,
            mensajeInputFechaTermino,
            mensajeInputUbicacion,
            mensajeInputnombreLicitacion,
            submitButton,
            licitacion,
            onSubmit,
        };
    },
};
